/**
 * Recursively collects all selected entity IDs from a billed entity tree.
 * Shared by billedEntitiesInterceptor and getBilledEntityIds.
 */
export function getAllEntityCodes(entities: any[]): string[] {
  let codes: string[] = [];
  entities.forEach((entity) => {
    if (entity.selected) {
      codes.push(entity.id);
    }
    if (entity.subEntities && entity.subEntities.length > 0) {
      codes = [...codes, ...getAllEntityCodes(entity.subEntities)];
    }
  });
  return codes;
}
